import React, { useState } from 'react';
import { NewProjectForm } from '../../components/portal/NewProjectForm';
import { ProjectList } from '../../components/portal/ProjectList';
import { ArchivedProjects } from '../../components/portal/ArchivedProjects';

/* Still exported from here because other pages import it from this path. */
export { rowStatusLabel } from '../../components/portal/ProjectList';
interface ProjectsProps {
  /** The New Project form is opened from the header. */
  creating: boolean;
  setCreating: (open: boolean) => void;
}

/**
 * The client list — the Clients tab.
 *
 * **There is deliberately no "Add New Client" button here (15 Oct 2026).**
 * One was added and taken straight back out at Tom's word. New Project in
 * the header is the way in and it is enough; a second door to the same flow
 * on the page below it is the kind of duplication that makes an interface
 * feel bigger than it is.
 *
 * **This was the front page until 23 Sep 2026**, carrying the greeting and
 * Needs Attention above the list. Both of those moved to `Home` when the Week
 * Ahead took the front page, because a list of clients is something you go to
 * once you know what you are doing, not the thing you arrive to find out.
 *
 * Two earlier removals from this page are worth not undoing:
 *
 *   • **Recent Activity** (15 Sep 2026) had sat in the right third since the
 *     beginning and never once showed a line — it only ever listed client
 *     approvals and change requests, and there have been none. What it would
 *     have shown duplicated Needs Attention anyway.
 *   • **"With the client"**, a count of deliverables in review (13 Sep 2026),
 *     for the same reason: every extra line dilutes the one thing the
 *     attention box exists to say.
 *
 * Still genuinely missing, and still belonging as a row inside Needs
 * Attention rather than as a panel here: whether a client has OPENED their
 * link at all. WFES was last opened on 9 September with two films waiting;
 * nobody at ATM has ever opened theirs. "Never opened" and "opened, no
 * answer" call for opposite responses — chase the link, or chase the decision.
 */
export function Projects({
  creating,
  setCreating
}: ProjectsProps) {
  const [showArchive, setShowArchive] = useState(false);
  if (showArchive) return <ArchivedProjects onBack={() => setShowArchive(false)} data-id="element-2462" data-mp="6wzujxd709we" />;
  return <div data-id="element-2463" data-mp="6w838yqmoybx">
      <h1 className="font-display text-4xl leading-[0.95] tracking-tight sm:text-6xl" data-id="element-2464" data-mp="6yu6wnaeetov">Clients</h1>
      {creating && <NewProjectForm onClose={() => setCreating(false)} data-id="element-2465" data-mp="3adq76v3a5l72" />}
      <ProjectList onShowArchive={() => setShowArchive(true)} data-id="element-2466" data-mp="3ae8agbod0zoh" />
    </div>;
}